import { SimpleGrid, TextInput } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import { Controller, type Control } from 'react-hook-form';
import type { SusFormValues } from './susFormSchema';

type Props = {
  control: Control<SusFormValues>;
  disabled: boolean;
};

const addressFields = [
  'adr_num_voie',
  'adr_type_voie',
  'adr_nom_voie',
  'adr_lieudit',
  'adr_code_postal',
  'adr_commune',
] as const;

type AddressField = (typeof addressFields)[number];

const requiredFields: readonly AddressField[] = ['adr_type_voie', 'adr_nom_voie', 'adr_commune'];

const errorKeys: Record<AddressField, string> = {
  adr_num_voie: 'admin.sus.form.error.adr_num_voie',
  adr_type_voie: 'admin.sus.form.error.adr_type_voie',
  adr_nom_voie: 'admin.sus.form.error.required',
  adr_lieudit: 'admin.sus.form.error.adr_code_postal',
  adr_code_postal: 'admin.sus.form.error.adr_code_postal',
  adr_commune: 'admin.sus.form.error.required',
};

/** Saisie de l'adresse postale du service d'urgence (tous les champs sont facultatifs). */
const SusAddressFields = ({ control, disabled }: Props) => {
  const { t } = useTranslate();

  return (
    <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="xs">
      {addressFields.map(name => (
        <Controller
          key={name}
          control={control}
          name={name}
          render={({ field, fieldState }) => (
            <TextInput
              {...field}
              label={t(`admin.sus.form.${name}`)}
              required={requiredFields.includes(name)}
              error={fieldState.error ? t(errorKeys[name]) : undefined}
              disabled={disabled}
            />
          )}
        />
      ))}
    </SimpleGrid>
  );
};

export default SusAddressFields;
